module.exports={
    "enus": {
        "50 gifts in one Gift Dashboard only.": "50 gifts in one Gift Dashboard only.",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%> sent you <%=count%> <%=name%>, check it out!",
        "Add a gift link below your Youtube or Facebook post.": "Add a gift link below your Youtube or Facebook post.",
        "Add friend": "Add friend",
        "Add friends and chat it up!": "Add friends and chat it up!",
        "Alipay": "Alipay",
        "Balance": "Balance",
        "Bank Transfer": "Bank Transfer",
        "Cancel": "Cancel",
        "CashCard(THB)": "CashCard(THB)",
        "Check out your revenue record here or in Uplive when you received a gift.": "Check out your revenue record here or in Uplive when you received a gift.",
        "Check revenue": "Check revenue",
        "Confirm": "Confirm",
        "Copied Successfully!": "Copied Successfully!",
        "Copied failed. Please select the link and copy.": "Copied failed. Please select the link and copy.",
        "Copy link": "Copy link",
        "Create Dashboard": "Create Dashboard",
        "Create Dashboard Btn": "Create Dashboard",
        "Create more dashboards": "Create more dashboards",
        "Current edits are not saved yet, jump to edit profile picture now?": "Current edits are not saved yet, jump to edit profile picture now?",
        "Customer Assistant": "Customer Assistant",
        "Customer Service": "Customer Service",
        "Dashboard created!": "Dashboard created!",
        "Dashboard failed to create.": "Dashboard failed to create.",
        "Dashboard failed to update;(": "Dashboard failed to update;(",
        "Dashboard updated!": "Dashboard updated!",
        "Describe this dashboard": "Describe this dashboard",
        "Description": "Description",
        "Edit profile picture": "Edit profile picture",
        "Engrave on Blockchain": "Engrave on Blockchain",
        "Engraving on Blockchain...": "Engraving on Blockchain...",
        "Enter project name": "Enter project name ",
        "Error.": "Service error, please try again later.",
        "Expired userToken.": "Expired userToken.",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "Failed to charge. Please try again.",
        "Failed to obtain personal info.": "Failed to obtain personal info.",
        "Failed to set up user\\'s county and area.": "Failed to set up user\\'s county and area.",
        "Friend request": "Friend request",
        "Friend request sent successfully.": "Friend request sent successfully.",
        "Friends": "Friends",
        "GIFTO钱包": "GIFTO Wallet",
        "Gift Dashboards": "Gift Dashboards",
        "Gift assistant": "Gift assistant",
        "Gifts": "Gifts",
        "Go to Uplive": "Go to Uplive",
        "How to get gifts?": "How to get gifts?",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!",
        "Insufficient balance, please recharge.": "Insufficient balance, please recharge.",
        "Invalid data.": "Invalid data.",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "It takes some time to engrave on blockchain you will get a message when it’s done!",
        "Last update": "Last update",
        "Leaderboard": "Leaderboard",
        "Limit is Description is 120 characters.": "Limit is Description is 120 characters.",
        "Limit of Name is 30 characters.": "Limit of Name is 30 characters.",
        "Limited to 130 characters": "Limited to 130 characters",
        "Limited to <%=count%> characters": "Limited to <%=count%> characters",
        "Loading": "Loading",
        "Loading...": "Loading...",
        "Log out": "Log out",
        "Login to Send Gift": "Login to Send Gift",
        "Make it Forever...": "Make it Forever...",
        "Message cannot be empty!": "Message cannot be empty!",
        "Messages": "Messages",
        "MyCard": "MyCard",
        "NEXT": "NEXT",
        "Name this Dashboard": "Name this Dashboard",
        "Next Step": "Next Step",
        "No more data": "No more data",
        "OK": "OK",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal": "PayPal",
        "Payment cancelled.": "Payment cancelled.",
        "Payment failed.": "Payment failed.",
        "Payment has been processed.": "Payment has been processed.",
        "Please login to recharge.": "Please recharge after login.",
        "Please name your dashboard.": "Please name your dashboard.",
        "Please recharge": "Please recharge",
        "Please select a valid image format.": "Please select a valid image format.",
        "Please select the link and copy.": "Please select the link and copy.",
        "Please select the sending gift first.": "Please select the sending gift first.",
        "Previous page": "Previous page",
        "QQ": "QQ",
        "Rankings": "Rankings",
        "Received gifts": "Received gifts",
        "Recharge amount": "Recharge amount",
        "Recharge option": "Recharge option",
        "Reselect": "Reselect",
        "Revenue": "Revenue",
        "Save": "Save",
        "Save Dashboard": "Save Dashboard",
        "Say something": "Say something",
        "Say something about yourself": "Say something about yourself",
        "See all >": "See all >",
        "Select from photo": "Select from photo",
        "Send": "Send",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "Send thanks!",
        "Session timeout.": "Session timeout.",
        "Sign in": "Sign in",
        "Step 1": "Step 1",
        "Step 1: Pick gifts for your new gift dashboard first.": "Step 1: Pick gifts for your new gift dashboard first.",
        "Step 2": "Step 2",
        "Step 2: Copy your new gift dashboard’s link.": "Step 2: Copy your new gift dashboard’s link.",
        "Step 3": "Step 3",
        "Step 3: Paste your new dashboard link under your creative content.": "Step 3: Paste your new dashboard link under your creative content.",
        "Swipe up to load more": "Swipe up to load more",
        "System error.": "System error.",
        "TOTAL REVENUE": "TOTAL REVENUE",
        "This name has been used": "This name has been used",
        "Tip: Resolution of 800x800 is suggested": "Tip: Resolution of 800x800 is suggested",
        "Tips:": "Tips:",
        "Transaction submitted.": "Transaction submitted.",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "Universal Gifting",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "Upload a higher resolution profile pic to receive more gifts!",
        "Uploading...": "Uploading...",
        "VIP等级不足": "Level up to view",
        "View on Blockchain": "View on Blockchain",
        "Wechat": "Wechat",
        "Weibo": "Weibo",
        "Withdraw": "Withdraw",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "You can create a project by Uplive web or app to generate a gift link.",
        "You could only create 10 Dashboards.": "You could only create 10 Dashboards.",
        "You have exceeded the daily limit": "You have exceeded the daily limit",
        "You two are friends now.": "You two are friends now.",
        "Your gift is now on blockchain !": "Your gift is now on blockchain!",
        "Your gift is on the way": "Your gift is on the way",
        "Your name": "Your name",
        "agree": "agree",
        "agreed": "agreed",
        "bk_atm": "bk_atm",
        "bk_card": "bk_card",
        "onecard": "onecard",
        "send": "Send",
        "send <%=giftName%>": "send <%=giftName%>",
        "skip": "skip",
        "uDiamonds": "uDiamonds",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "It needs <%=fee%> GTO to engrave on blockchain.",
        "你还有未完成的交易，请稍后再试": "You have unfinished transactions, please wait.",
        "保存并分享": "Save and Share",
        "分享到Line": "Share to Line",
        "分享到Telegram": "Share to Telegram",
        "创建链接": "Create Link",
        "删除面板不会影响你收到的礼物": "Delete this board will not affect the gifts you've received.",
        "发布到FB!": "Post to Facebook!",
        "取消": "Cancel",
        "同意": "Okay",
        "图片已经成功保存到你的设备上了": "Gift saved on your device!",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "Facebook/Instagram/...You can start receiving gifts anywhere now!",
        "地址已经成功复制到剪切板了": "Address copied.",
        "复制地址": "Copy",
        "存款到这个账户": "Deposit to this account",
        "完成": "Done",
        "建议至少选择3~5礼物": "Pick at least 3~5 gifts.",
        "开始收礼物吧！": "Start getting gifts now!",
        "得到链接并复制": "Get link and copy",
        "快來看看我精心定制的禮物吧！": "Come check out my customized gifts!",
        "把礼物链接发送到你的Facebook或者Youtube": "Send the gift link to your Facebook or Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "This dashboard received <span class=\"red\"><%=amount%></span> gifts, worth of <span class=\"red\"><%=value%></span> GTO.",
        "放弃": "Give up",
        "正在加载数据...": "Loading...",
        "没有找到匹配的礼物": "Couldn't find matched gift.",
        "点击查看": "Click to check out on Blockchain!",
        "生成图片...": "Creating the gift...",
        "确认删除": "Delete",
        "确认删除该礼物面板? 删除后将不可恢复": "Delete this board? This board cannot be resumed.",
        "礼物记录不存在": "Gift doesn't exist.",
        "礼物面板删除成功！": "Board deleted",
        "编辑文字": "Edit message",
        "要放弃本次头像修改吗？": "Give up changing profile pic?",
        "试试": "Give it a try",
        "该地区暂未开放": "Not available in this region",
        "该用户的地区暂未支持GIFTO礼物": "The user's region does not currently support GIFTO gifts",
        "该礼物已失效": "This gift has expired. ",
        "跳过的提示文本": "This is your last chance to engrave this message and the gift on blockchain.",
        "输入备注的提示文本": "Write what you want to engrave onto the blockchain here...",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "Sending fun gifts become so easy!-GIFTO- Universal Gifting",
        "选择礼物": "Pick Gifts",
        "重新播放": "Replay"
    },
    "kokr": {
        "50 gifts in one Gift Dashboard only.": "각 선물함의 선물은 최대 50개까지 지원됩니다!",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%> 님께서 <%=name%> (을)를 <%=count%> 개 보냈습니다，얼른확인해보세요！",
        "Add a gift link below your Youtube or Facebook post.": "좋은 선물함을 만들어 자신의 유튜브, 페이스북 등 플랫폼의 포스팅 내용을 상세기술 항목에 기입하세요.",
        "Add friend": "친구 추가",
        "Add friends and chat it up!": "친구 추가하세요! 채팅으로 친구들의 관계는 더욱 좋아질 거에요!",
        "Alipay": "알리페이",
        "Balance": "잔액",
        "Bank Transfer": "계좌이체",
        "Cancel": "취소",
        "CashCard(THB)": "CashCard(THB)",
        "Check out your revenue record here or in Uplive when you received a gift.": "언제든 이 함 혹은 Uplive app을 통해서 수익 기록을 확인할 수 있습니다.",
        "Check revenue": "수익확인",
        "Confirm": "확인",
        "Copied Successfully!": "복사 성공!",
        "Copied failed. Please select the link and copy.": "복사 실패, 직접 링크를 선택하고 복사하세요.",
        "Copy link": "링크 복사",
        "Create Dashboard": "선물함 만들기",
        "Create Dashboard Btn": "새로운 선물함 생성",
        "Create more dashboards": "새로운 선물함 만들기",
        "Current edits are not saved yet, jump to edit profile picture now?": "현재 작업이 아직 저장되지 않았습니다, 편집을 중단하고 개인 프로필 사진 함으로 넘어갈까요?",
        "Customer Assistant": "고객 서비스",
        "Customer Service": "고객 서비스",
        "Dashboard created!": "새로운 선물함 생성을 성공했습니다!",
        "Dashboard failed to create.": "선물함 생성을 실패하였습니다.",
        "Dashboard failed to update;(": "업데이트 실패;(",
        "Dashboard updated!": "선물함을 업데이트 했습니다!",
        "Describe this dashboard": "선물함을 설명해 주세요",
        "Description": "상세 설명",
        "Edit profile picture": "프로필 사진 편집",
        "Engrave on Blockchain": "블록체인에 저장되었습니다.",
        "Engraving on Blockchain...": "블록체인에 저장중...",
        "Enter project name": "선물함 이름 입력",
        "Error.": "에러.",
        "Expired userToken.": "만료된 사용자의 정보입니다.",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "충전 실패,다시 시도해주세요.",
        "Failed to obtain personal info.": "사용자 소식 받아오기를 실패하였습니다.",
        "Failed to set up user\\'s county and area.": "사용자 지역 받아오기를 실패하였습니다.",
        "Friend request": "친구 신청",
        "Friend request sent successfully.": "친구신청 보내기 성공",
        "Friends": "친구",
        "GIFTO钱包": "GIFTO 지갑",
        "Gift Dashboards": "선물함",
        "Gift assistant": "선물 도우미",
        "Gifts": "선물",
        "Go to Uplive": "Uplive 실행",
        "How to get gifts?": "어떻게 선물을 받을 수 있나요?",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "<%=itemName%> 을(를) <%=name%> 님에게 <%=count%> 개 보냈습니다，얼른 확인 해보세요！",
        "Insufficient balance, please recharge.": "잔액이 부족합니다. 충전해주세요.",
        "Invalid data.": "데이터가 유효하지 않습니다.",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "블록체인에 새겨지는데 시간이 소요될 수 있습니다. 완료 후 메시지 알람을 보내드립니다.",
        "Last update": "수정일자",
        "Leaderboard": "순위보드",
        "Limit is Description is 120 characters.": "상세 설명은 120자를 넘을 수 없습니다.",
        "Limit of Name is 30 characters.": "이름은 30자를 넘을 수 없습니다.",
        "Limited to 130 characters": "130자로 제한됩니다.",
        "Limited to <%=count%> characters": "<%=count%> 자로 제한 됩니다.",
        "Loading": "로딩중",
        "Loading...": "로딩중...",
        "Log out": "로그아웃",
        "Login to Send Gift": "로그인하시면 바로 선물을 보낼 수 있습니다.",
        "Make it Forever...": "새겨보세요",
        "Message cannot be empty!": "메시지는 비워둘 수 없습니다.",
        "Messages": "메시지",
        "MyCard": "MyCard",
        "NEXT": "다음",
        "Name this Dashboard": "선물함 이름",
        "Next Step": "다음 단계",
        "No more data": "더 이상 데이터가 없습니다.",
        "OK": "좋아요.",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal": "PayPal",
        "Payment cancelled.": "결제를 취소하였습니다.",
        "Payment failed.": "결제를 실패하였습니다.",
        "Payment has been processed.": "결제 성공!",
        "Please login to recharge.": "로그인 후 충전하십시오.",
        "Please name your dashboard.": "선물함 이름을 만들어주세요.",
        "Please recharge": "충전해주세요.",
        "Please select a valid image format.": "올바른 형식의 사진을 선택해주세요.",
        "Please select the link and copy.": "직접 링크를 선택하고 복사하세요.",
        "Please select the sending gift first.": "보내실 선물을 먼저 선택해주세요.",
        "Previous page": "이전 페이지",
        "QQ": "QQ",
        "Rankings": "순위표",
        "Received gifts": "받은 선물",
        "Recharge amount": "충전금액",
        "Recharge option": "충전선택",
        "Reselect": "다시 선택",
        "Revenue": "수익",
        "Save": "저장",
        "Save Dashboard": "선물함 저장",
        "Say something": "뭐든 말 좀 해봐…",
        "Say something about yourself": "자기소개",
        "See all >": "모두 보기>",
        "Select from photo": "사진첩에서 선택하기",
        "Send": "보내기",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "감사 인사",
        "Session timeout.": "페이지가 만료되었습니다.",
        "Sign in": "로그인",
        "Step 1": "1단계",
        "Step 1: Pick gifts for your new gift dashboard first.": "1단계: 자신의 새로운 선물함에서 선물을 선택하세요.",
        "Step 2": "2단계",
        "Step 2: Copy your new gift dashboard’s link.": "2단계: 자신의 새로운 선물함 링크를 복사하세요.",
        "Step 3": "3단계",
        "Step 3: Paste your new dashboard link under your creative content.": "3단계: 자신이 포스팅한 선물함 내용의 링크를 붙여넣으세요.",
        "Swipe up to load more": "페이지를 위로 올려 더 많이 불러오세요",
        "System error.": "시스템 에러.",
        "TOTAL REVENUE": "총 수익",
        "This name has been used": "같은 이름이 이미 있습니다",
        "Tip: Resolution of 800x800 is suggested": "팁: 권장 해상도는 800x800 입니다.",
        "Tips:": "팁:",
        "Transaction submitted.": "거래가 처리되었습니다.",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "유니버셜 기프팅",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "고화질의 프로필 사진을 등록하면 선물 받을 기회가 늘어납니다!",
        "Uploading...": "업로드중…",
        "VIP等级不足": "VIP레벨이 낮습니다.",
        "View on Blockchain": "보러가기",
        "Wechat": "위챗",
        "Weibo": "웨이보",
        "Withdraw": "현금 인출",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "Uplive app 을(를) 통해서만 현금 인출이 가능합니다. Uplive 을(를) 실행시켜주세요.",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "자신만의 선물함을 만들어 보세요",
        "You could only create 10 Dashboards.": "선물함은 10개까지 만들 수 있습니다.",
        "You have exceeded the daily limit": "당일 충전금액 한도를 초과하였습니다.",
        "You two are friends now.": "서로 친구가 되었습니다.",
        "Your gift is now on blockchain !": "당신의 선물이 블록체인화 되었습니다. ",
        "Your gift is on the way": "선물을 보내는 중입니다",
        "Your name": "당신의 이름은",
        "agree": "수락하였습니다.",
        "agreed": "이미 수락하였습니다.",
        "bk_atm": "bk_atm결제",
        "bk_card": "bk_card결제",
        "onecard": "onecard",
        "send": "보내기",
        "send <%=giftName%>": "<%=giftName%> 을(를)보내기",
        "skip": "넘어가기",
        "uDiamonds": "U다이아몬드",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "블록체인화 하는데 <%=fee%> GTO가 필요합니다.",
        "你还有未完成的交易，请稍后再试": "거래가 완료되지 않았습니다. 다시 시도해주세요.",
        "保存并分享": "저장 및 공유",
        "分享到Line": "라인으로 공유하기",
        "分享到Telegram": "텔레그램으로 공유하기",
        "创建链接": "링크 생성",
        "删除面板不会影响你收到的礼物": "아이템 패널 삭제는 선물받은 아이템과 무관합니다.",
        "发布到FB!": "페이스북 포스팅",
        "取消": "취소",
        "同意": "확인",
        "图片已经成功保存到你的设备上了": "선물 이미지가 디바이스에 성공적으로 저장되었습니다. ",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "Facebook/Instagram 등 어디서든 업라이브의 아이템을 받을 수 있어요!",
        "地址已经成功复制到剪切板了": "클립보드에 주소 복사 성공",
        "复制地址": "주소 복사",
        "存款到这个账户": "계좌에 입금 성공",
        "完成": "완료",
        "建议至少选择3~5礼物": "최소 3 ~ 5 선물을 선택하는 것이 좋습니다~",
        "开始收礼物吧！": "아이템 받으러 오세요~",
        "得到链接并复制": "링크 받은 후 복사하기",
        "快來看看我精心定制的禮物吧！": "Come check out my customized gifts!",
        "把礼物链接发送到你的Facebook或者Youtube": "아이템 링크를 페이스북이나 유튜브에 전송하기",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "<%=amount%>개 아이템을 받았습니다. 해당 가치는 <%=value%> GTO입니다.",
        "放弃": "취소",
        "正在加载数据...": "수치입력중...",
        "没有找到匹配的礼物": "매칭하는 아이템을 찾을 수 없습니다.",
        "点击查看": "터치하여 확인하기",
        "生成图片...": "선물이 생성 중입니다...",
        "确认删除": "정말 삭제하시겠습니까?",
        "确认删除该礼物面板? 删除后将不可恢复": "해당 아이템 패널을 삭제하시겠습니까? 삭제 후 복구 불가합니다.",
        "礼物记录不存在": "선물이 없습니다",
        "礼物面板删除成功！": "아이템 패널 삭제 성공!",
        "编辑文字": "메시지 수정",
        "要放弃本次头像修改吗？": "프로필 수정을 취소하시겠습니까?",
        "试试": "미리보기",
        "该地区暂未开放": "해당 지역은 서비스 준비 전입니다.",
        "该礼物已失效": "선물이 만료되었습니다.",
        "跳过的提示文本": "블록체인화는 한 번 밖에 할 수 없습니다.<br/>지금 취소하면 메세지와 선물을 블록체인화 할 수 없습니다.",
        "输入备注的提示文本": "블록체인에 남기고 싶은 메시지를 작성해 주세요...",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "아이템 선물이 쉬워졌어요!-GIFTO- 유니버셜 기프팅",
        "选择礼物": "아이템 선택",
        "重新播放": "재시도"
    },
    "vivn": {
        "GIFTO钱包": "Ví GTO",
        "Send <%=value%> GTO": "Gửi <%=value%> GTO",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "VIP等级不足": "Level VIP chưa đủ",
        "删除面板不会影响你收到的礼物": "Xóa bảng quà tặng này không ảnh hướng đến việc nhận quà của bạn",
        "取消": "Hủy",
        "地址已经成功复制到剪切板了": "Địa chỉ đã được sao chép đến bảng tạm",
        "复制地址": "Sao chép địa chỉ",
        "存款到这个账户": "Gửi tiền vào tài khoản này",
        "建议至少选择3~5礼物": "Ít nhất chọn từ 3-5 món quà~",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "Nhận được <%=amount%> món quà, trị giá <%=value%> GTO",
        "正在加载数据...": "Đang tải ...",
        "没有找到匹配的礼物": "Chưa tìm được quà phù hợp",
        "确认删除": "Xác nhận",
        "确认删除该礼物面板? 删除后将不可恢复": "Bạn có chắc sẽ xóa bảng quà tặng này? Sau khi xóa không thể khôi phục lại",
        "礼物面板删除成功！": "Đã xóa thành công bảng quà tặng!",
        "要放弃本次头像修改吗？": "Bạn không muốn thay đổi Avatar? ",
        "该地区暂未开放": "Khu vực này hiện chưa ra mắt tính năng",
        "该用户的地区暂未支持GIFTO礼物": "Khu vực này hiên chưa mở tính năng GIFTO"
    },
    "zhcn": {
        "50 gifts in one Gift Dashboard only.": "每个礼物面板只支持选择50个礼物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>给你送了<%=count%>个<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "将创建好的礼物面板链接贴到你在Youtube、Facebook等平台发布的内容文字描述里。",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加个好友吧！聊天能让你们的关系更好哦！",
        "Alipay": "支付宝",
        "Balance": "余额",
        "Bank Transfer": "银行转账",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "随时通过提现页面或者Uplive app查看你的收益记录。",
        "Check revenue": "查看收益",
        "Confirm": "确定",
        "Copied Successfully!": "复制成功！",
        "Copied failed. Please select the link and copy.": "复制失败，请手动选中链接并复制。",
        "Copy link": "复制链接",
        "Create Dashboard": "创建礼物面板",
        "Create Dashboard Btn": "创建新的礼物面板",
        "Create more dashboards": "创建新的礼物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "当前编辑还未保存，舍弃编辑并跳转到个人头像页面吗？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的礼物面板创建成功！",
        "Dashboard failed to create.": "礼物面板创建失败",
        "Dashboard failed to update;(": "更新失败=(",
        "Dashboard updated!": "礼物面板成功更新！",
        "Describe this dashboard": "该礼物面板的描述",
        "Description": "描述",
        "Edit profile picture": "编辑头像",
        "Engrave on Blockchain": "篆刻到区块链",
        "Engraving on Blockchain...": "正在篆刻到区块链...",
        "Enter project name": "输入礼物面板名称",
        "Error.": "服务出错了。请稍候再试。",
        "Expired userToken.": "过期的用户信息。",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "充值失败，请重新尝试。",
        "Failed to obtain personal info.": "获取用户信息失败。",
        "Failed to set up user\\'s county and area.": "获取用户的地区失败。",
        "Friend request": "好友申请",
        "Friend request sent successfully.": "好友申请发送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO钱包",
        "Gift Dashboards": "礼物面板",
        "Gift assistant": "礼物助手",
        "Gifts": "礼物",
        "Go to Uplive": "打开Uplive",
        "How to get gifts?": "如何获得礼物打赏？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在<%=itemName%>给你送了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "余额不足,请充值",
        "Invalid data.": "无效的数据。",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "篆刻到区块链需要一点时间，成功后我们会发消息通知你。",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "项目描述不能超过120字符",
        "Limit of Name is 30 characters.": "项目名字不能超过30字符",
        "Limited to 130 characters": "130字符限制",
        "Limited to <%=count%> characters": "<%=count%>字符限制",
        "Loading": "加载中",
        "Loading...": "加载中...",
        "Log out": "登出",
        "Login to Send Gift": "登录即可送礼",
        "Make it Forever...": "让此刻永驻",
        "Message cannot be empty!": "信息不能为空。",
        "Messages": "信息",
        "MyCard": "MyCard",
        "NEXT": "下一步",
        "Name this Dashboard": "礼物面板名称",
        "Next Step": "下一步",
        "No more data": "没有更多数据了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消了。",
        "Payment failed.": "支付失败了。",
        "Payment has been processed.": "支付成功！",
        "Please login to recharge.": "请先登录再进行充值。",
        "Please name your dashboard.": "请给你新的礼物面板命名",
        "Please recharge": "请充值。",
        "Please select a valid image format.": "请选择一个正确的图片格式。",
        "Please select the link and copy.": "请手动选择链接并复制。",
        "Please select the sending gift first.": "请先选中要送的礼物。",
        "Previous page": "上一页",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的礼物",
        "Recharge amount": "充值金额",
        "Recharge option": "充值选项",
        "Reselect": "重新选择",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存礼物面板",
        "Say something": "说点什么吧……",
        "Say something about yourself": "自我介绍",
        "See all >": "查看所有>",
        "Select from photo": "从相册中选择",
        "Send": "发送",
        "Send <%=value%> GTO": "送出 <%=value%> GTO",
        "Send thanks!": "答谢TA",
        "Session timeout.": "页面超时。",
        "Sign in": "登录",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：为你的全新礼物面板选择礼物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：复制你全新礼物面板的超链接。",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你发布的内容下方粘贴礼物面板链接。",
        "Swipe up to load more": "上划页面可加载更多",
        "System error.": "系统错误。",
        "TOTAL REVENUE": "总收益",
        "This name has been used": "项目名称已存在",
        "Tip: Resolution of 800x800 is suggested": "小贴士：建议清晰度为800x800。",
        "Tips:": "小贴士：",
        "Transaction submitted.": "交易已提交。",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用礼物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上传高清的头像可以提高获得礼物的机会哦！",
        "Uploading...": "上传中...",
        "VIP等级不足": "VIP等级不足",
        "View on Blockchain": "去查看",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提现",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通过Uplive app提现，请打开Uplive。",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "创建你自己的礼物面板",
        "You could only create 10 Dashboards.": "目前只能创建10个不同的礼物面板。",
        "You have exceeded the daily limit": "你超过了每日充值的额度上限。",
        "You two are friends now.": "你们已成为了朋友。",
        "Your gift is now on blockchain !": "你的礼物已发送到区块链!",
        "Your gift is on the way": "您的礼物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "skip": "跳过",
        "uDiamonds": "u钻",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "篆刻到区块链需要<%=fee%> GTO",
        "你还有未完成的交易，请稍后再试": "您还有未完成的交易，请稍后再试",
        "保存并分享": "保存并分享",
        "分享到Line": "分享到Line",
        "分享到Telegram": "分享到Telegram",
        "创建链接": "创建链接",
        "删除面板不会影响你收到的礼物": "删除面板不会影响你收到的礼物",
        "发布到FB!": "发布到FB!",
        "取消": "取消",
        "同意": "同意",
        "图片已经成功保存到你的设备上了": "图片已经成功保存到你的设备上了",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！",
        "地址已经成功复制到剪切板了": "已成功复制到剪切板。",
        "复制地址": "复制地址",
        "存款到这个账户": "存款到这个账户",
        "完成": "完成",
        "建议至少选择3~5礼物": "建议至少选择3~5礼物",
        "开始收礼物吧！": "开始收礼物吧！",
        "得到链接并复制": "获得链接并复制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把礼物链接发送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "这个礼物面板收到 <span class=\"red\"><%=amount%></span> 个礼物, 价值 <span class=\"red\"><%=value%></span> GTO",
        "放弃": "放弃",
        "正在加载数据...": "正在加载数据...",
        "没有找到匹配的礼物": "没有找到匹配的礼物",
        "点击查看": "快到区块链上查看吧！",
        "生成图片...": "正在生成礼物...",
        "确认删除": "确认删除",
        "确认删除该礼物面板? 删除后将不可恢复": "确认删除该礼物面板? 删除后将不可恢复",
        "礼物记录不存在": "礼物记录不存在",
        "礼物面板删除成功！": "礼物面板删除成功！",
        "编辑文字": "编辑留言",
        "要放弃本次头像修改吗？": "要放弃本次头像修改吗？",
        "试试": "试一试",
        "该地区暂未开放": "该地区暂未开放",
        "该用户的地区暂未支持GIFTO礼物": "该用户的地区暂未支持GIFTO礼物",
        "该礼物已失效": "该礼物已失效。",
        "跳过的提示文本": "篆刻机会只有一次，现在放弃就会永久失去对这段留言和礼物进行篆刻的机会。",
        "输入备注的提示文本": "你在此的留言将有机会篆刻到区块链上......",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "选择礼物",
        "重新播放": "重新播放"
    },
    "zhhk": {
        "50 gifts in one Gift Dashboard only.": "每個禮物面板只支援選擇50個禮物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>給你發送了<%=count%>個<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "將創建好的禮物面板鏈接，貼到你在Youtube、Facebook等平台發布的內容文字描述裏",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加個好友吧！聊天能讓你們的關係更好哦！",
        "Alipay": "支付寶",
        "Balance": "餘額",
        "Bank Transfer": "銀行轉帳",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "通過提現頁面或者Uplive app可以隨時查看你的收入記錄。",
        "Check revenue": "查看收益",
        "Confirm": "確定",
        "Copied Successfully!": "複製成功！",
        "Copied failed. Please select the link and copy.": "複製失敗，請手動選中鏈接並複製",
        "Copy link": "複製鏈接",
        "Create Dashboard": "創建禮物面板",
        "Create Dashboard Btn": "創建新的禮物面板",
        "Create more dashboards": "創建新的禮物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "當前編輯還未保存，捨棄編輯並跳轉到個人頭像頁面嗎？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的禮物面板創建成功！",
        "Dashboard failed to create.": "禮物面板創建失敗",
        "Dashboard failed to update;(": "更新失敗",
        "Dashboard updated!": "禮物面板成功",
        "Describe this dashboard": "該禮物面板的描述",
        "Description": "描述",
        "Edit profile picture": "編輯頭像",
        "Enter project name": "輸入禮物面板名稱",
        "Error.": "服務出錯了。請稍候再試。",
        "Expired userToken.": "過期的用戶訊息",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "充值失敗，請重新嘗試",
        "Failed to obtain personal info.": "獲取用戶訊息失敗",
        "Failed to set up user\\'s county and area.": "獲取用戶地區失敗",
        "Friend request": "好友申請",
        "Friend request sent successfully.": "好友申請發送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO錢包",
        "Gift Dashboards": "禮物面板",
        "Gift assistant": "禮物助手",
        "Gifts": "禮物",
        "Go to Uplive": "開啟Uplive",
        "How to get gifts?": "如何獲得禮物？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在 <%=itemName%>給你發了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "餘額不足請充值",
        "Invalid data.": "無效數據",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "項目描述不能高過120字元",
        "Limit of Name is 30 characters.": "項目名字不能超過30字元",
        "Loading": "加載中",
        "Loading...": "載入中...",
        "Log out": "登出",
        "Login to Send Gift": "登入即可送禮",
        "Message cannot be empty!": "訊息不能為空",
        "Messages": "訊息",
        "MyCard": "MyCard",
        "Name this Dashboard": "禮物面板名稱",
        "Next Step": "下一步",
        "No more data": "沒有更多資料了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消",
        "Payment failed.": "支付失敗",
        "Payment has been processed.": "支付成功",
        "Please login to recharge.": "請先登錄再進行充值。",
        "Please name your dashboard.": "請給你的新禮物面板命名",
        "Please recharge": "請充值",
        "Please select a valid image format.": "請選擇一個正確的圖片格式",
        "Please select the link and copy.": "請手動選擇鏈接並複製",
        "Please select the sending gift first.": "請先選要送的禮物",
        "Previous page": "上一頁",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的禮物",
        "Recharge amount": "充值金額",
        "Recharge option": "充值選項",
        "Reselect": "重新選擇",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存禮物面板",
        "Say something": "說點什麼吧",
        "Say something about yourself": "自我介紹",
        "See all >": "查看所有>",
        "Select from photo": "從相冊中選擇",
        "Send": "發送",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "感謝他",
        "Session timeout.": "頁面超時",
        "Sign in": "登入",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：為你的全新禮物面板選擇禮物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：複製你全新禮物面板的超鏈接",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你發布的內容下方貼上禮物面板鏈接",
        "Swipe up to load more": "將頁面向上拉來加載更多內容",
        "System error.": "系統錯誤",
        "TOTAL REVENUE": "總收益",
        "This name has been used": "項目名稱已存在",
        "Tip: Resolution of 800x800 is suggested": "溫馨提示：建議清晰度為800X800",
        "Tips:": "提醒：",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用禮物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上傳高清的頭像可以提高獲得禮物的機會哦！",
        "Uploading...": "上傳中...",
        "VIP等级不足": "VIP等級不足",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提現",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通過Uplive app提現，請開啟Uplive",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "創建你自己的禮物面板",
        "You could only create 10 Dashboards.": "目前只能創建10個不同的禮物面板。",
        "You have exceeded the daily limit": "你超過了每日充值的額度上限",
        "You two are friends now.": "你們已經成為朋友",
        "Your gift is on the way": "您的禮物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "uDiamonds": "U鑽",
        "你还有未完成的交易，请稍后再试": "您還有未完成的交易，請稍後再試",
        "创建链接": "創建鏈接",
        "删除面板不会影响你收到的礼物": "刪除板面不會影響你收到的禮物",
        "发布到FB!": "發布到FB!",
        "取消": "取消",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "係Facebook/Instagram/...任何地方都可以用Uplive收禮物啦！",
        "地址已经成功复制到剪切板了": "已成功複製到Clipboard",
        "复制地址": "複製地址",
        "存款到这个账户": "存款到這個帳戶",
        "建议至少选择3~5礼物": "建議至少選擇3~5禮物～",
        "开始收礼物吧！": "開始收禮物吧！",
        "得到链接并复制": "獲得鏈接並複制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把禮物鏈接發送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "收到<%=amount%>個禮物, 價值 <%=value%> GTO",
        "正在加载数据...": "正在載入數據...",
        "没有找到匹配的礼物": "沒有找到匹配的禮物",
        "确认删除": "確認刪除",
        "确认删除该礼物面板? 删除后将不可恢复": "確認刪除該禮物板面？刪除後將不可恢復",
        "礼物面板删除成功！": "禮物板面刪除成功！",
        "要放弃本次头像修改吗？": "要放棄本次頭像修改嗎？",
        "该地区暂未开放": "該地區暫未開放",
        "该用户的地区暂未支持GIFTO礼物": "該用戶的地區暫未支持GIFTO禮物",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "選擇禮物"
    },
    "zhtw": {
        "50 gifts in one Gift Dashboard only.": "每個禮物面板只支援選擇50個禮物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>給你發送了<%=count%>个<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "將創建好的禮物面板鏈接貼到你在Youtube、Facebook等平台發布的內容文字描述裡",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加個好友吧！聊天能讓你們的關係更好哦！",
        "Alipay": "支付寶",
        "Balance": "餘額",
        "Bank Transfer": "銀行轉帳",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "隨時通過提現頁面或者Uplive app查看你的收益紀錄",
        "Check revenue": "查看收益",
        "Confirm": "確定",
        "Copied Successfully!": "複製成功！",
        "Copied failed. Please select the link and copy.": "複製失敗，請手動選中鏈接並複製",
        "Copy link": "複製鏈接",
        "Create Dashboard": "創建禮物面板",
        "Create Dashboard Btn": "創建新的禮物面板",
        "Create more dashboards": "創建新的禮物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "當前編輯還未保存，捨棄編輯並跳轉到個人頭像頁面嗎？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的禮物面板創建成功！",
        "Dashboard failed to create.": "禮物面板創建失敗",
        "Dashboard failed to update;(": "更新失敗",
        "Dashboard updated!": "禮物面板成功！",
        "Describe this dashboard": "該禮物面板的描述",
        "Description": "描述",
        "Edit profile picture": "編輯頭像",
        "Engrave on Blockchain": "雕刻到區塊鏈",
        "Engraving on Blockchain...": "正在雕刻到區塊鏈...",
        "Enter project name": "輸入禮物面板名稱",
        "Error.": "服務出錯了。請稍候再試。",
        "Expired userToken.": "過期的用戶訊息",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "儲值失敗，請重新嘗試",
        "Failed to obtain personal info.": "獲取用戶訊息失敗",
        "Failed to set up user\\'s county and area.": "獲取用戶地區失敗",
        "Friend request": "好友申請",
        "Friend request sent successfully.": "好友申請發送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO錢包",
        "Gift Dashboards": "禮物面板",
        "Gift assistant": "禮物助手",
        "Gifts": "禮物",
        "Go to Uplive": "打開Uplive",
        "How to get gifts?": "如何獲得禮物打賞？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在 <%=itemName%>給你發了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "餘額不足請充值",
        "Invalid data.": "無效數據",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "雕刻到區塊鏈需要一點時間，成功後我們會發消息通知你。",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "項目描述不能高過120字元",
        "Limit of Name is 30 characters.": "項目名字不能超過30字元",
        "Limited to 130 characters": "130字元限制",
        "Limited to <%=count%> characters": "<%=count%>字元限制",
        "Loading": "載入中",
        "Loading...": "載入中...",
        "Log out": "登出",
        "Login to Send Gift": "登入即可送禮",
        "Make it Forever...": "讓此刻永駐",
        "Message cannot be empty!": "訊息不能為空",
        "Messages": "訊息",
        "MyCard": "MyCard",
        "NEXT": "下一步",
        "Name this Dashboard": "禮物面板名稱",
        "Next Step": "下一步",
        "No more data": "沒有更多資料了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消",
        "Payment failed.": "支付失敗",
        "Payment has been processed.": "支付成功！",
        "Please login to recharge.": "請先登錄再進行充值。",
        "Please name your dashboard.": "請給你的新禮物面板命名",
        "Please recharge": "請儲值",
        "Please select a valid image format.": "請選擇一個正確的圖片格式",
        "Please select the link and copy.": "請手動選擇鏈接並複製",
        "Please select the sending gift first.": "請先選要送的禮物",
        "Previous page": "上一頁",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的禮物",
        "Recharge amount": "儲值金額",
        "Recharge option": "儲值選項",
        "Reselect": "重新選擇",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存禮物面板",
        "Say something": "說點什麼吧",
        "Say something about yourself": "自我介紹",
        "See all >": "查看所有>",
        "Select from photo": "從相冊中選擇",
        "Send": "發送",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "感謝TA",
        "Session timeout.": "頁面超時",
        "Sign in": "登入",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：為你的全新禮物面板選擇禮物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：複製你全心禮物面板的超鏈接",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你發布的內容下方貼上禮物面板鏈接",
        "Swipe up to load more": "上劃頁面來加載更多",
        "System error.": "系統錯誤",
        "TOTAL REVENUE": "總收益",
        "This name has been used": "項目名稱已存在",
        "Tip: Resolution of 800x800 is suggested": "提醒：建議清晰度為800X800",
        "Tips:": "提醒：",
        "Transaction submitted.": "交易已提交。",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用禮物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上傳高清的頭像可以提高獲得禮物的機會哦！",
        "Uploading...": "上傳中...",
        "VIP等级不足": "VIP等級不足",
        "View on Blockchain": "去查看",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提現",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通過Uplive app提現，請打開Uplive",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "創建你自己的禮物面板",
        "You could only create 10 Dashboards.": "目前只能創建10個不同的禮物面板。",
        "You have exceeded the daily limit": "你超過了每日儲值的額度上限",
        "You two are friends now.": "你們已成為了朋友",
        "Your gift is now on blockchain !": "你的禮物已發送到區塊鏈!",
        "Your gift is on the way": "您的禮物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "skip": "跳過",
        "uDiamonds": "U鑽",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "雕刻到區塊鏈需要<%=fee%> GTO",
        "你还有未完成的交易，请稍后再试": "您還有未完成的交易，請稍後再試",
        "保存并分享": "保存並分享",
        "分享到Line": "分享到Line",
        "分享到Telegram": "分享到Telegram",
        "创建链接": "創建鏈接",
        "删除面板不会影响你收到的礼物": "刪除面板不會影響你收到的禮物",
        "发布到FB!": "發布到FB!",
        "取消": "取消",
        "同意": "同意",
        "图片已经成功保存到你的设备上了": "圖片已經成功保存到你的設備上了",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "在Facebook/Instagram/...任何地方都可以用Uplive收禮物啦！",
        "地址已经成功复制到剪切板了": "已成功複製到剪貼簿",
        "复制地址": "複製地址",
        "存款到这个账户": "存入這個帳戶",
        "完成": "完成",
        "建议至少选择3~5礼物": "建議至少選擇3~5禮物噢～",
        "开始收礼物吧！": "開始收禮物吧！",
        "得到链接并复制": "獲得鏈接並複制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把禮物鏈接發送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "這個禮物面板收到 <span class=\"red\"><%=amount%></span>個禮物，價值 <span class=\"red\"><%=value%></span> GTO",
        "放弃": "放棄",
        "正在加载数据...": "正在載入數據...",
        "没有找到匹配的礼物": "沒有找到匹配的禮物",
        "点击查看": "快到區塊鏈上查看吧！",
        "生成图片...": "正在生成禮物...",
        "确认删除": "確認刪除",
        "礼物记录不存在": "禮物記錄不存在",
        "礼物面板删除成功！": "確認刪除該禮物面板？刪除後將不可恢復",
        "编辑文字": "編輯留言",
        "要放弃本次头像修改吗？": "要放棄本次頭像修改嗎？",
        "试试": "試一試",
        "该地区暂未开放": "該地區暫未開放",
        "该用户的地区暂未支持GIFTO礼物": "該用戶的地區暫未支持GIFTO禮物",
        "该礼物已失效": "該禮物已失效。",
        "跳过的提示文本": "雕刻機會只有一次，現在放棄就會永久失去對這段留言和禮物進行刻上區塊鏈的機會。",
        "输入备注的提示文本": "你在此的留言將有機會雕刻到區塊鏈上......",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "選擇禮物",
        "重新播放": "重新播放"
    }
}


// WEBPACK FOOTER //
// ./js/lang/pack.js